package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class SearchHistoryDto(
    val id: Int,
    val query: String,
    val filters: SearchFiltersDto? = null,
    val resultsCount: Int? = null,
    val createdAt: String,
)

@Serializable
data class SearchFiltersDto(
    val tags: List<String>? = null,
    val author: String? = null,
    val dateFrom: String? = null,
    val dateTo: String? = null,
    val sortBy: String? = null,
)

@Serializable
data class SearchHistoryListDto(
    val history: List<SearchHistoryDto>,
)
